import { catchError, map, throwError } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ReportHubService } from './service/report-hub.service';
import { reportListInterface } from 'src/app/util/interfaces/reportList';
import { faArrowUpRightFromSquare, faDownload, faGear, faPenToSquare, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global/global.service';
import { LoadingNotificationService } from 'src/app/services/loading-notification/loading-notification.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

type ReportRow = Record<string, any>;
type ReportResponse = {
	columns: mspTableHeaderI[];
	data: ReportRow[];
};

@Component({
	selector: 'app-report-hub',
	templateUrl: './report-hub.component.html',
	styleUrls: ['./report-hub.component.scss'],
})
export class ReportHubComponent implements OnInit {
	icons = {
		faGear: faGear,
		faPenToSquare: faPenToSquare,
		faArrowUpRightFromSquare: faArrowUpRightFromSquare,
		faDownload: faDownload,
		faTrash: faTrash,
		faXmark: faXmark,
	};

	labels: LabelsInterface = {
		lbl_geral_reports: '',
		lbl_create_report: '',
		lbl_geral_voltar: '',
		lbl_relatorios_salvos: '',
		lbl_rep_custom_nao_ha_relatorios: '',
		lbl_edocs_carregando: '',
		lbl_geral_chamado: '',
		lbl_status_estoque: '',
		lbl_cmdb: '',
		lbl_geral_deletado_com_sucesso: '',
		lbl_clique_confirmar_acao: '',
		lbl_geral_excluir_relatorio: '',
		lbl_geral_clique_aqui_baixar_arquivo: '',
		lbl_geral_editar_relatorio: '',
		lbl_visualizar_relatorio: '',
		lbl_selecione_tipo_relatorio: '',
		lbl_acao_demorada: '',
		lbl_baixar_relatorio: '',
		lbl_planilha_mais_100_registros_baixar_relatorio: '',
		lbl_geral_avaliar: 'Evaluate',
		lbl_chamado_avaliacoes: 'Evaluation',
		lbl_pesquisa_de_satisfacao_personalizada: 'Custom Satisfaction Survey',
		lbl_geral_relatorio: '',
		lbl_security_nenhum_registro: '',
		lbl_geral_acompanhamento_log: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private ReportHubService: ReportHubService,
		private NotificationService: NotificationService,
		private ExcelService: ExcelService,
		private Route: ActivatedRoute,
		private router: Router,
		private LoadingNotificationService: LoadingNotificationService,
		public PermissionService: PermissionService
	) {}

	pageView = 'report-list';
	idSelectedReport: string = undefined;
	reportType: { name: 'request' | 'cmdb' | 'stock' | 'evaluate'; label: string } = { name: undefined, label: undefined };
	reportSubType: { name: string; label: string } = { name: undefined, label: undefined };
	reportSubTypeOptions: { name: string; label: string }[] = [];

	isLoadingLabels = true;
	isLoadingReportList = false;
	isLoadingReportData = false;
	isDeletingReport = false;
	isLoadingCockpit = false;
	isOpenModalEvaluationMSP = false;

	reportList: reportListInterface[] = [];
	reportData: ReportResponse = { columns: [], data: [] };
	reportDataInView: any[][]; //Para armazenar o retorno pós configuração de colunas para download;
	reportHeader: mspTableHeaderI[] = [];
	reportDataRework: ReportRow[] = [];

	selectReportType = '';
	selectReportSubType = '';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.Route.queryParams.subscribe((parameters) => {
			if (parameters && parameters.gt) {
				if (parameters.gt === 'cmdb' && this.PermissionService.hasPermission('access_cmdb')) {
					this.pageView = 'report-select-sub';
					this.reportType = { name: 'cmdb', label: 'lbl_cmdb' };
					this.setSubTypeOptions();
				}

				if (parameters.gt === 'stock' && this.PermissionService.hasPermission('access_stock')) {
					this.pageView = 'report-select-sub';
					this.reportType = { name: 'stock', label: 'lbl_status_estoque' };
					this.setSubTypeOptions();
				}

				if (parameters.gt === 'request' && this.PermissionService.hasPermission('access_request')) {
					this.pageView = 'report-select-sub';
					this.reportType = { name: 'request', label: 'lbl_geral_chamado' };
					this.setSubTypeOptions();
				}

				if (parameters.gt === 'evaluate') {
					this.pageView = 'report-select-sub';
					this.reportType = { name: 'evaluate', label: 'lbl_chamado_avaliacoes' };
					this.setSubTypeOptions();
				}
			}

			// Indicadores do Cockpit
			if (parameters && parameters['idIndicator']) {
				const queryParameters = this.Route.snapshot.queryParams;
				const idReport = queryParameters['idReport'];
				const idIndicator = queryParameters['idIndicator'];
				const getter_limit = queryParameters['getter_limit'];
				const getType = queryParameters['getType'];
				const genericParameter1 = queryParameters['genericParam1'];
				const dateRange = queryParameters['dateRange'];
				const storedCustomDate = JSON.parse(localStorage.getItem('customDate'));

				this.isLoadingCockpit = true;

				if (localStorage.getItem('ckpL') === '3') {
					this.ReportHubService.getReportData(
						idReport,
						this.reportType.name,
						this.reportSubType.name,
						getter_limit,
						'',
						getType,
						idIndicator,
						genericParameter1,
						dateRange,
						storedCustomDate.startDate,
						storedCustomDate.endDate
					).subscribe((reportData) => {
						this.reportData = <any>reportData;
						this.pageView = 'report-read';
						this.isLoadingCockpit = false;
					});
				} else {
					this.ReportHubService.getReportData(
						idReport,
						this.reportType.name,
						this.reportSubType.name,
						getter_limit,
						'',
						getType,
						idIndicator,
						genericParameter1,
						dateRange
					).subscribe((reportData) => {
						this.reportData = <any>reportData;
						this.pageView = 'report-read';
						this.isLoadingCockpit = false;
					});
				}
			}
		});

		this.getUserReport();
	}

	getUserReport(): void {
		this.isLoadingReportList = true;
		this.ReportHubService.getReportList().subscribe((reportList) => {
			this.reportList = reportList;
			let selectedReportId = '';
			let selectedReportType = '';
			let selectedReportSubType = '';
			this.Route.queryParams.subscribe((parameter) => {
				if (parameter.id) {
					for (let index = 0; index < this.reportList.length; index++) {
						const report = this.reportList[index];
						if (report.id != parameter.id) continue;
						selectedReportId = parameter.id;
						selectedReportType = report.type;
						selectedReportSubType = report.sub_type;
						break;
					}
				}
			});

			if (selectedReportId == '') {
				window.history.replaceState({}, '', '/report');
			} else {
				this.getReportData(selectedReportId, selectedReportType, selectedReportSubType, selectedReportId);
			}
			this.isLoadingReportList = false;
		});
	}

	setSubTypeOptions(): void {
		if (this.reportType.name === 'request') {
			this.reportSubTypeOptions = [
				{ name: 'general', label: 'lbl_extracao_geral' },
				{ name: 'task', label: 'lbl_chamado_tarefas' },
				{ name: 'satisfaction', label: 'lbl_geral_satisfacao' },
				{ name: 'satisfactionCustom', label: 'lbl_pesquisa_de_satisfacao_personalizada' },
				{ name: 'taskAndCustomFields', label: 'lbl_geral_campos_customizados_e_tarefas' },
				{ name: 'logs', label: 'lbl_geral_acompanhamento_log' },
			];
			return;
		}

		if (this.reportType.name === 'cmdb') {
			this.reportSubTypeOptions = [
				{ name: 'equipmentHistoryByUser', label: 'lbl_historico_equipamentos_usuario' },
				{ name: 'general', label: 'lbl_extracao_geral' },
				{ name: 'reportCost', label: 'lbl_projetos_custo' },
				{ name: 'withoutRelated', label: 'lbl_geral_work_without_contract' },
				{ name: 'logIntegrationInventory', label: 'lbl_geral_log_integration_inventory' },
				{ name: 'software', label: 'lbl_asset_sw_instalados' },
				{ name: 'software_x_license', label: 'lbl_cmdb_licenca' },
				{ name: 'calculateMonthlyDepreciation', label: 'lbl_geral_accumulated_depreciation' },
				{ name: 'reportAD', label: 'lbl_microad_notexist_cmdb' },
				{ name: 'reportMicroNotAD', label: 'lbl_micro_notexist_ad' },
				{ name: 'workstationsInventory', label: 'lbl_asset_inventario_micros' },
			];
			return;
		}

		if (this.reportType.name === 'stock') {
			this.reportSubTypeOptions = [
				{ name: 'consumables', label: 'lbl_asset_consumiveis' },
				{ name: 'newItems', label: 'lbl_geral_novos_itens' },
				{ name: 'stockLoan', label: 'lbl_stock_emprestimo' },
			];
			return;
		}

		if (this.reportType.name === 'evaluate') {
			this.reportSubTypeOptions = [{ name: 'userEvaluation', label: 'lbl_avaliacoes_MySupport' }];
			return;
		}

		this.reportSubTypeOptions = [];
	}

	handleReportSubtypeSelection(subtype: { name: string; label: string }): void {
		if (subtype.name === 'equipmentHistoryByUser') {
			this.router.navigate(['/cmdb/equipment-history']);
			return;
		}

		this.reportSubType = subtype;
		this.pageView = 'register';
	}

	deleteReport(idReport: string): void {
		if (this.isDeletingReport) return;
		this.idSelectedReport = idReport;
		this.isDeletingReport = true;
		this.ReportHubService.deleteReportList(idReport).subscribe(() => {
			for (const [index, reportItem] of this.reportList.entries()) {
				if (reportItem.id === idReport) {
					this.reportList.splice(index, 1);
				}
			}
			this.idSelectedReport = undefined;
			this.selectReportType = undefined;
			this.selectReportSubType = undefined;
			this.isDeletingReport = false;
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
		});
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirm');
		setTimeout(() => {
			elementReference.classList.remove('confirm');
		}, 5000);
	}

	breakRow(text: string): string {
		if (!text) return '';

		// Substituir códigos HTML por quebras de linha reais
		text = text.replaceAll(/&#60;br&#62;/gi, '\n');
		text = text.replaceAll(/&#60;br&#62;/gi, '\n');
		text = text.replaceAll(/<br>/gi, '\n');
		text = text.replaceAll(/<\/br>/gi, '\n');
		text = text.replaceAll(/<b>/gi, '');
		text = text.replaceAll(/<\/b>/gi, '');

		// Remover espaços em branco extras no início e fim de cada linha
		text = text
			.split('\n')
			.map((line) => line.trim())
			.join('\n');

		// Remover linhas vazias consecutivas
		text = text.replaceAll(/\n{3,}/g, '\n\n');

		return text;
	}

	formatSpacing(text: string): string {
		if (!text) return '';

		// Substituir códigos HTML por quebras de linha reais
		text = text.replaceAll(/&#60;br&#62;/gi, ' ');
		text = text.replaceAll(/&#60;br&#62;/gi, ' ');
		text = text.replaceAll(/<br>/gi, ' ');
		text = text.replaceAll(/<\/br>/gi, ' ');
		text = text.replaceAll(/<b>/gi, '');
		text = text.replaceAll(/<\/b>/gi, '');

		return text;
	}

	getReportData(idReport: string, type: string, subtype: string, nameReport: string): void {
		if (this.isLoadingReportData) return;
		this.idSelectedReport = idReport;
		this.selectReportType = type;
		this.selectReportSubType = subtype;
		this.isLoadingReportData = true;
		this.NotificationService.setNotificationMessage(this.labels.lbl_acao_demorada);
		this.ReportHubService.getReportData(idReport, type, subtype, 100).subscribe(
			(reportData) => {
				this.reportHeader = reportData.columns;
				this.reportDataRework = reportData.data.map((item) => {
					const itemKeys = Object.keys(item);
					const normalizedItem = this.reportHeader.reduce<ReportRow>((result, headerItem) => {
						const sourceKey = itemKeys.find((key) => key.toLowerCase() === headerItem.name.toLowerCase()) ?? headerItem.name;
						result[headerItem.name] = item[sourceKey] ?? '';
						return result;
					}, {});

					for (const key of Object.keys(item)) {
						if (!(key in normalizedItem)) normalizedItem[key] = item[key];
					}

					if (normalizedItem.NOTES) {
						normalizedItem.NOTES = this.breakRow(normalizedItem.NOTES);
					}
					return normalizedItem;
				});

				this.reportData = {
					...reportData,
					data: this.reportDataRework,
				};
				if (this.reportData.data.length >= 100) {
					this.reportData.data = this.reportData.data.slice(0, 100);
					this.reportDataRework = this.reportData.data;
					this.NotificationService.setNotificationMessage(this.labels.lbl_planilha_mais_100_registros_baixar_relatorio);
				}
				this.pageView = 'report-read';
				window.history.replaceState({}, '', `/report?id=${idReport}`);
				this.isLoadingReportData = false;
			},
			() => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_security_nenhum_registro);
				this.isLoadingReportData = false;
			}
		);
	}

	downloadReport(idReport: string, type: string, subtype: string, nameReport: string): void {
		this.idSelectedReport = idReport;
		const idNotificaton = this.LoadingNotificationService.setNotificationMessage(
			`${this.labels.lbl_geral_relatorio} - ${nameReport}`,
			'loading',
			'faFileAlt'
		);
		this.ReportHubService.getReportData(idReport, type, subtype, 5000)
			.pipe(
				catchError((error) => {
					console.error('Erro ao obter os dados do relatório:', error);
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
					return throwError(() => error);
				})
			)
			.subscribe(
				(reportData) => {
					reportData.data = reportData.data.map((item) => {
						const upperCaseItem = {};
						for (const key of Object.keys(item)) {
							const upperKey = key.toUpperCase();
							upperCaseItem[upperKey] = item[key];
							if (upperKey === 'NOTES' && upperCaseItem[upperKey]) {
								upperCaseItem[upperKey] = this.formatSpacing(upperCaseItem[upperKey]);
							}
						}
						return upperCaseItem;
					});
					const reportDataArray = this.ExcelService.convertMspTableInto2d(reportData.columns, reportData.data);
					this.ExcelService.exportAsExcelFile(<any>reportDataArray, idReport);
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
					this.idSelectedReport = undefined;
				},
				() => {
					this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
				}
			);
	}

	downloadInViewReport(): void {
		this.downloadReport(this.idSelectedReport, this.selectReportType, this.selectReportSubType, this.idSelectedReport);
		this.NotificationService.setFunctionOnMessage;
	}

	setSubType(): void {
		//This is necessary since we have mocked subtype information
		this.setSubTypeOptions();
		for (const subType of this.reportSubTypeOptions) {
			if (subType.name == this.reportSubType.name) {
				this.reportSubType = subType;
			}
		}
	}

	resetReportHub(): void {
		this.Route.queryParams.subscribe((parameters) => {
			if (parameters && parameters['idIndicator']) {
				this.router.navigate(['cockpit']);
			} else {
				this.pageView = 'report-list';
				this.idSelectedReport = undefined;
				this.selectReportType = undefined;
				this.selectReportSubType = undefined;
				this.reportType = { name: undefined, label: undefined };
				this.reportSubType = { name: undefined, label: undefined };
				this.reportData = { columns: [], data: [] };
				this.reportDataRework = [];
				this.reportHeader = [];
				this.router.navigate(['/report']);
				this.getUserReport();
			}
		});
	}

	// Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
	modalClose(event: Event, ignorePropagation: boolean): void {
		if (event.target === document.querySelector('#modalClose')) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
		if (ignorePropagation) {
			this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
		}
	}

	openModalEvaluationMSP() {
		this.isOpenModalEvaluationMSP = !this.isOpenModalEvaluationMSP;
	}
	// Final Função para fechar o modal ao ser clicado em áreas que não fazem parte do modal
}
